import { IParticipantCourseGroupQuery } from '../interfaces/participant-course-group.query.interface';
import { ProgramItem } from './program-item.model';

// @dynamic
export class PartcipantCourseGroup {
    programItems: ProgramItem[];
    isExpanded: boolean;
    groupStatsCoursesBooked: number;
    groupStatsCoursesCompleted: number;

    constructor(query: IParticipantCourseGroupQuery) {
        this.programItems = query.program_items.length ? query.program_items.map((programItem) => new ProgramItem(programItem)) : [];
        this.isExpanded = query.program_items.length ? query.program_items.some((programItem) => programItem.course_progress_status === 'in_progress') : false;
        this.groupStatsCoursesBooked = query.group_stats_courses_booked;
        this.groupStatsCoursesCompleted = query.group_stats_courses_completed;
    }
}
